function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import handleClipboard from "@/utils/clipboard";
import { definePropType } from "@types-vue/props";
import EditShowTitle from "@pt/components/edit-show-title.vue";
import imageNotFound from "@com/assets/default_small.png";
import { defineComponent, ref } from "vue";
export default defineComponent({
    components: {
        EditShowTitle: EditShowTitle
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        url: {
            type: String,
            default: ""
        },
        id: [
            String,
            Number
        ],
        type: {
            type: String,
            default: ""
        },
        value: {
            type: String,
            default: ""
        },
        hasPhoto: {
            type: Boolean,
            default: true
        },
        editable: {
            type: Boolean,
            default: true
        },
        beforeEmit: {
            type: definePropType(Function)
        },
        activable: {
            type: Boolean,
            default: false
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleCopy = function handleCopy() {
            handleClipboard(String(props.id), {
                target: ".id-content",
                delegateTarget: document.querySelector("#clipboardElement")
            });
        };
        var handleClick = function handleClick() {
            if (props.disabled) return;
            emit("click");
        };
        var editValue = ref("");
        var inputProp = {
            maxlength: 60,
            showWordLimit: true,
            size: "mini"
        };
        var editShowTitleRef = ref();
        function handleEdit(name) {
            return _handleEdit.apply(this, arguments);
        }
        function _handleEdit() {
            _handleEdit = _asyncToGenerator(regeneratorRuntime.mark(function _callee(name) {
                var _$ref;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _ctx.next = 3;
                            return (_$ref = props.beforeEmit) === null || _$ref === void 0 ? void 0 : _$ref.call(props, name);
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _handleEdit.apply(this, arguments);
        }
        return {
            editValue: editValue,
            imageNotFound: imageNotFound,
            inputProp: inputProp,
            editShowTitleRef: editShowTitleRef,
            handleEdit: handleEdit,
            handleCopy: handleCopy,
            handleClick: handleClick
        };
    }
});
